var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"chartCanvas",style:(_vm.chartSize)})
}
var staticRenderFns = []

export { render, staticRenderFns }